import { memo } from 'react';
import type { TextRenderProps } from './TextRender';
import TextRender from './TextRender';

const Paragraph = (props: TextRenderProps) => {
    return <TextRender {...props} component="p" />;
};

export default memo(Paragraph);
